/**
 * BillingCancel — route /billing/cancel
 *
 * Stripe redirects here when the customer exits checkout without paying.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoUrl from '../../assets/images/cleveroo-logo.png';
import '../../components/AccountPages.css';

const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="cvr-account">
      <div className="cvr-account__bar">
        <span className="cvr-account__brand">
          <img src={logoUrl} alt="" />
          Cleveroo
        </span>
      </div>

      <div
        className="cvr-account__wrap"
        style={{ maxWidth: 520, textAlign: 'center' }}
      >
        {/* Info icon */}
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: '#EFE6D0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '32px auto 0',
          }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6B7A6F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h1
          className="cvr-account__title"
          style={{ fontSize: 28, marginTop: 24, textAlign: 'center' }}
        >
          Checkout canceled
        </h1>
        <p
          style={{
            color: '#6B7A6F',
            fontSize: 16,
            marginTop: 12,
            lineHeight: 1.65,
          }}
        >
          No worries — nothing was charged. Whenever you're ready, you can start
          your free trial from the pricing page.
        </p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            marginTop: 32,
            alignItems: 'center',
          }}
        >
          <button
            className="cvr-btn"
            onClick={() => navigate('/billing')}
            style={{ padding: '13px 32px', fontSize: 15 }}
          >
            Back to pricing
          </button>
          <button
            className="cvr-btn cvr-btn--ghost"
            onClick={() => navigate('/')}
            style={{ fontSize: 14 }}
          >
            Go to dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingCancel;
